import { render } from "./DashboardStorageHistory.vue?vue&type=template&id=8c80ba2c&scoped=true&ts=true"
import script from "./DashboardStorageHistory.vue?vue&type=script&lang=ts"
export * from "./DashboardStorageHistory.vue?vue&type=script&lang=ts"

import "./DashboardStorageHistory.vue?vue&type=style&index=0&id=8c80ba2c&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c80ba2c"]])

export default __exports__